'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CollectionFilterSingle = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _functional = require('../utils/functional');

var _listeners = require('../utils/listeners');

var _utils = require('../utils');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var classes = {
  ACTIONS_FLOAT: 'clc-Filters_Actions-float',
  ACTIONS_HIDE: 'clc-Filters_Actions-hide'
};

var CollectionFilterSingle = exports.CollectionFilterSingle = function () {
  function CollectionFilterSingle(_ref) {
    var el = _ref.el,
        context = _ref.context;
    (0, _classCallCheck3.default)(this, CollectionFilterSingle);

    this.el = el;
    this.context = context;
    this.autoScrolling = false;

    this.setupListeners();

    var selected = '';
    var filterTitle = '';

    this.getAllButtons().forEach(function (button) {
      if (JSON.parse(button.getAttribute('aria-current'))) {
        selected = button.dataset.value;
        filterTitle = button.dataset.title;
      }
    });

    this.selectedFilter = {
      el: el,
      filterTitle: filterTitle,
      selected: selected

      /**
       * Sets the height of the Filters' Body element, to avoid flickering when
       * filter button moves to fixed position
       */
    };if ((0, _utils.mediaBreakpointMatches)('xs')) {
      this.getBody().style.height = this.getActions().getBoundingClientRect().height.toFixed(2) + 'px';
    }
  }

  (0, _createClass3.default)(CollectionFilterSingle, [{
    key: 'setupListeners',
    value: function setupListeners() {
      this.listeners = new _listeners.Listeners();
      this.listeners.add(this.el, 'click', this.handleButtonClick.bind(this));
      this.listeners.add(window, 'scroll', this.onScroll.bind(this));
    }
  }, {
    key: 'handleButtonClick',
    value: function handleButtonClick(_ref2) {
      var target = _ref2.target;

      if (!this.hasButton(target)) return;

      this.getAllButtons().forEach(function (button) {
        if (target.dataset.value === button.dataset.value) {
          button.setAttribute('aria-current', 'true');
        } else {
          button.setAttribute('aria-current', 'false');
        }
      });

      this.selectedFilter.selected = target.dataset.value;
      this.selectedFilter.filterTitle = target.dataset.title;

      var tags = [this.selectedFilter.selected];
      var title = [this.selectedFilter.filterTitle];
      this.dispatchEvent(tags, title);
    }
  }, {
    key: 'dispatchEvent',
    value: function dispatchEvent(tags, title) {
      this.el.dispatchEvent(new CustomEvent('filterChange', {
        detail: { tags: tags, title: title }
      }));
    }
  }, {
    key: 'getAllButtons',
    value: function getAllButtons() {
      return (0, _functional.getElements)(this.selectors.button, { context: this.el });
    }
  }, {
    key: 'getButton',
    value: function getButton(el) {
      return el.closest(this.selectors.button);
    }
  }, {
    key: 'hasButton',
    value: function hasButton(el) {
      return this.getButton(el) != null;
    }
  }, {
    key: 'getActionsWrapper',
    value: function getActionsWrapper() {
      return (0, _functional.getElement)(this.selectors.actionsWrapper, { context: this.el });
    }
  }, {
    key: 'getActions',
    value: function getActions() {
      return (0, _functional.getElement)(this.selectors.actions, { context: this.el });
    }
  }, {
    key: 'getBody',
    value: function getBody() {
      return (0, _functional.getElement)(this.selectors.body, { context: this.el });
    }
  }, {
    key: 'onScroll',
    value: function onScroll() {
      if (!(0, _utils.mediaBreakpointMatches)('xs') || this.autoScrolling) return false;

      var actionsWrapper = this.getActionsWrapper();
      var actions = this.getActions();
      var scrollOffsetTop = window.pageYOffset;
      var headerHeight = parseInt((0, _utils.getPropertyValue)('--Header_Height'));
      var actionsWrapperOffset = window.pageYOffset + actionsWrapper.getBoundingClientRect().top;
      var actionsHeight = 50;
      var offset = 100;

      if (scrollOffsetTop + headerHeight < actionsWrapperOffset + actionsHeight + offset) {
        if (actions.classList.contains(classes.ACTIONS_HIDE) || actions.classList.remove(classes.ACTIONS_FLOAT)) {
          actions.classList.remove(classes.ACTIONS_HIDE);
          actions.classList.remove(classes.ACTIONS_FLOAT);
        }
      } else {
        if (!actions.classList.contains(classes.ACTIONS_FLOAT)) {
          actions.classList.add(classes.ACTIONS_FLOAT);
        }

        var scrollDirection = scrollOffsetTop >= this.lastKnownYPos ? 'DOWN' : 'UP';

        if (scrollDirection === 'DOWN') {
          if (!actions.classList.contains(classes.ACTIONS_HIDE)) {
            actions.classList.add(classes.ACTIONS_HIDE);
          }
        } else {
          if (actions.classList.contains(classes.ACTIONS_HIDE)) {
            actions.classList.remove(classes.ACTIONS_HIDE);
          }
        }
      }

      this.lastKnownYPos = window.pageYOffset;
    }
  }, {
    key: 'selectors',
    get: function get() {
      return {
        button: '.' + this.context.className + '_Button',
        actionsWrapper: '.' + this.context.className + '_ActionsWrapper',
        body: '.' + this.context.className + '_Body',
        actions: '.' + this.context.className + '_Actions'
      };
    }
  }]);
  return CollectionFilterSingle;
}();